import PropTypes from 'prop-types';
import { DefaultStyle, PlainCardStyle, PraiseStyle, TodoStyle } from './EntityStyles';

const entityShapes = {
    TODO: 'TODO',
    PLAIN_CARD: 'PLAIN_CARD',
    PRAISE: 'PRAISE',
};

type Props = { entityShape?: keyof typeof entityShapes };

LoadingContentIndicator.propTypes = {
    entityShape: PropTypes.oneOf(Object.keys(entityShapes)),
};

export default function LoadingContentIndicator({ entityShape }: Props) {
    if (entityShape === 'TODO') {
        return <TodoStyle />;
    }

    if (entityShape === 'PLAIN_CARD') {
        return <PlainCardStyle />;
    }

    if (entityShape === entityShapes.PRAISE) {
        return <PraiseStyle />;
    }

    return <DefaultStyle />;
}
